const URL = {
  GET_USER_LIMITS: 'Limit/GetUserLimits',
  CUSTOMER_PORTAL: 'Payment/CreateCustomerPortalSession',
  CUSTOMER_PORTAL_UPGRADE: 'Payment/CreateCustomerPortalSessionForUpgrade',
}

export default URL
